import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { MotionConfig } from "framer-motion";
import WhatsAppButton from "@/components/site/WhatsAppButton";
import SiteSchema from "@/components/seo/SiteSchema";

const Home = lazy(() => import("@/pages/Home"));
const About = lazy(() => import("@/pages/About"));
const Services = lazy(() => import("@/pages/Services"));
const Blogs = lazy(() => import("@/pages/Blogs"));
const BlogPost = lazy(() => import("@/pages/BlogPost"));
const VisualEditor = lazy(() => import("@/components/site/VisualEditor"));

function PageFallback() {
    return <div className="min-h-screen bg-white" aria-label="Loading page" />;
}

function App() {
    return (
        <MotionConfig reducedMotion="user">
            <div className="App">
                <BrowserRouter>
                    <SiteSchema />
                    <Suspense fallback={<PageFallback />}>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/services" element={<Services />} />
                            <Route path="/blog" element={<Blogs />} />
                            <Route path="/blog/:slug" element={<BlogPost />} />
                        </Routes>
                    </Suspense>
                </BrowserRouter>
                {process.env.NODE_ENV !== "production" && (
                    <Suspense fallback={null}>
                        <VisualEditor />
                    </Suspense>
                )}
                <WhatsAppButton />
                <Toaster position="bottom-right" theme="dark" richColors closeButton />
            </div>
        </MotionConfig>
    );
}

export default App;
